import { ReactElement } from "react";
import { UserMenuMemberWithCompany } from "types";
import { buildWebPath, buildCsToolsPath } from "lib/resource-finder";
import styles from "./user-links.module.css";
import { useSwitchCompaniesMutation } from "types/generated/operations";
import { asyncThrow } from "@justworkshr/fe-utility-kit";
import { pkceIsEnabled, oktaAuth } from "app/okta";
import { ACCOUNT_SETTINGS_LINK } from "../accountSettingsLink";

const { userLinks, userLink, buttonLink } = styles;

let companyList: JSX.Element[];

interface UserLinksProps {
  uuid: string;
  csTools?: boolean;
  profileView?: boolean;
  otherCompaniesOfCurrentUser?: UserMenuMemberWithCompany[];
}

export default function UserLinks({
  uuid,
  csTools,
  profileView,
  otherCompaniesOfCurrentUser,
}: UserLinksProps): ReactElement {
  const [switchCompanies] = useSwitchCompaniesMutation();

  let internalControls = <></>;

  if (csTools) {
    internalControls = (
      <a className={userLink} href={buildCsToolsPath()}>
        <span>Internal controls</span>
      </a>
    );
  }

  const handleSwitchCompanies = async (targetCompanyUuid: string) => {
    try {
      const response = await switchCompanies({
        variables: {
          targetCompanyUuid,
        },
      });
      if (response.data?.switchCompanies?.success) {
        const path = buildWebPath("/dashboard");
        window.location.assign(path);
      }
    } catch {
      // TODO: Better to show an error notification
      asyncThrow("Failed to switch companies");
    }
  };

  if (otherCompaniesOfCurrentUser) {
    companyList = otherCompaniesOfCurrentUser.map((element) => (
      <button
        key={element.company.uuid}
        className={[userLink, buttonLink].join(" ")}
        onClick={() => handleSwitchCompanies(element.company.uuid)}
      >
        <span>{element.company.name}</span>
      </button>
    ));
  }

  return (
    <ul title="User links" className={userLinks} data-testid="user-links">
      {profileView ? (
        <a className={userLink} href={buildWebPath(`employee_profile/${uuid}`)}>
          <span>View profile</span>
        </a>
      ) : (
        ""
      )}
      <a className={userLink} href={ACCOUNT_SETTINGS_LINK}>
        <span>Account settings</span>
      </a>
      {internalControls}
      {companyList}
      <button
        className={[userLink, buttonLink].join(" ")}
        onClick={async () => {
          if (pkceIsEnabled()) {
            return oktaAuth.signOut();
          }
          window.location.href = buildWebPath("/logout");
        }}
      >
        <span>Logout</span>
      </button>
    </ul>
  );
}
